<template>
	<div class="landing-page faq-category">
		<!-- Top navbar -->
		<landing-page-navbar></landing-page-navbar>

		<div class="faq-category-content">
			<!-- Hero banner -->
			<div class="hero-banner">
				<div class="container">
					<h1>Where is Likewize Repair?</h1>
				</div>
			</div>

			<div class="container">
				<div class="row">
					<div class="col-lg-4">
						<faq-category-menu active="location"></faq-category-menu>
					</div>
					<div class="col-lg-8">
						<faq-item v-for="(faq, index) in locationFaqs" :key="index" :faq="faq"></faq-item>
						<div class="container px-0">
							<faq-contact-banner></faq-contact-banner>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Footer -->
		<page-footer></page-footer>

	</div>
</template>

<script>
import {mapGetters} from "vuex"

export default {
	computed: {
		...mapGetters([
			'locationFaqs'
		])
	}
}
</script>

<style scoped>

</style>